import { API_URL } from '../../../app-config/constants';
import PaymentDoc, { PaymentDocDownloadLink, PaymentDocType } from '../../../types/PaymentDoc';
import { get } from '../request';

getPaymentDocs.operation = 'READ';

export function getPaymentDocs(type: PaymentDocType) {
    return get<PaymentDoc[]>(`${API_URL}/your-billing/payment-docs/${type}`);
}

export function getPaymentDocDownloadLink(type: PaymentDocType, paymentDocId: string) {
    return get<PaymentDocDownloadLink>(`${API_URL}/your-billing/download/${type}/${paymentDocId}`);
}

export function getPaymentDocsForCompany(type: PaymentDocType, companyId: string) {
    return get<PaymentDoc[]>(`${API_URL}/billing/${companyId}/payment-docs/${type}`);
}

export function getPaymentDocDownloadLinkForCompany(type: PaymentDocType, companyId: string, paymentDocId: string) {
    return get<PaymentDocDownloadLink>(`${API_URL}/billing/${companyId}/download/${type}/${paymentDocId}`);
}
